import { getSizeClasses, getAlignClasses, getContainerWidthClasses } from "./card-styles"

// interface LoadingSkeletonProps {
//   layout: "single" | "horizontal"
//   statsCount?: number
//   className?: string
//   size?: CardSize
//   contentAlign?: ContentAlign
//   backgroundColor?: string
//   connection?: CardConnection
// }

export default function LoadingSkeleton({
    layout,
    statsCount = 3,
    className = "",
    size = "md",
    contentAlign = "left",
    backgroundColor = "bg-white",
    connection = "separated",
}) {
    const sizeClasses = getSizeClasses(size)
    const alignClasses = getAlignClasses(contentAlign)
    const containerWidthClasses = getContainerWidthClasses(size, layout)

    if (layout === "single") {
        return (
            <div className={`${containerWidthClasses} ${className}`}>
                <div className={`border border-gray-200 rounded-lg ${backgroundColor} shadow-sm ${sizeClasses}`}>
                    <div className={`flex justify-between items-start ${alignClasses}`}>
                        <div className="flex flex-col flex-1">
                            {/* 標題 skeleton */}
                            <div className="h-5 bg-gray-200 rounded animate-pulse mb-4 w-24"></div>

                            {/* 主要數字 skeleton */}
                            <div className="h-12 bg-gray-200 rounded animate-pulse mb-2 w-32"></div>

                            {/* 變化指標 skeleton */}
                            <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
                        </div>

                        {/* 圖標 skeleton */}
                        <div className="w-6 h-6 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                </div>
            </div>
        )
    }

    if (connection === "connected") {
        return (
            <div className={`w-full ${className}`}>
                <div className={`border border-gray-200 rounded-lg ${backgroundColor} shadow-sm ${sizeClasses}`}>
                    <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-200">
                        {Array.from({ length: statsCount }).map((_, index) => (
                            <div key={index} className="pt-6 md:pt-0 md:px-6 first:pt-0 first:md:pl-0 last:md:pr-0">
                                <div className={`flex flex-col ${alignClasses}`}>
                                    {/* 數字 skeleton */}
                                    <div className="h-8 md:h-10 bg-gray-200 rounded animate-pulse mb-2 w-20"></div>

                                    {/* 標籤 skeleton */}
                                    <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={`w-full ${className}`}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {Array.from({ length: statsCount }).map((_, index) => (
                    <div key={index} className={`border border-gray-200 rounded-lg ${backgroundColor} shadow-sm ${sizeClasses}`}>
                        <div className={`flex flex-col ${alignClasses}`}>
                            {/* 數字 skeleton */}
                            <div className="h-8 md:h-10 bg-gray-200 rounded animate-pulse mb-2 w-20"></div>
                            {/* 標籤 skeleton */}
                            <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
